/** Stable key so we do not call setState when ReactGrid row model content is unchanged. */
export default function derivedRowsSyncKey(
  rows:
    | {
        rowId?: string | number;
        id?: string | number;
        cells?: { isLoading?: boolean }[];
      }[]
    | undefined,
): string {
  if (!rows?.length) {
    return '0';
  }
  const loadingCount = rows.reduce(
    (count, row) => count + (row?.cells?.some((cell) => cell?.isLoading) ? 1 : 0),
    0,
  );
  return `${rows.length}:${loadingCount}:${rows
    .map((row) => row?.rowId ?? row?.id ?? '')
    .join('|')}`;
}
